import React from "react";
import { useCurrency } from "@/lib/currencyCtx";

export default function CurrencyToggle() {
  const { currency, setCurrency } = useCurrency();
  return (
    <div className="inline-flex border border-atf-border bg-white" data-testid="currency-toggle">
      {["INR", "USD"].map((c) => (
        <button
          key={c}
          data-testid={`currency-${c}`}
          onClick={() => setCurrency(c)}
          className={`px-3 py-1.5 text-[11px] tracking-[0.18em] uppercase font-semibold transition-colors
            ${currency === c ? "bg-atf-brand text-white" : "text-atf-text2 hover:bg-atf-subtle"}`}
        >
          {c === "INR" ? "INR ₹" : "USD $"}
        </button>
      ))}
    </div>
  );
}
